<cbc-container [isLoading]="isLoading" [showContainer]="!isLoading && router.url === '/my-account/profiles'"
  title="Gerenciador de Perfis" description="Gerencie seus perfis de atendimento">
</cbc-container>

@if (!isLoading && router.url == '/my-account/profiles'){
<div class="container">

  @if(profileProviderPF.length > 0){
  <section class="mb-xl">
    <div class="title-secondary mb-md">Perfil Prestador de Consultas Pessoa Física</div>
    <div class="card">
      <table mat-table [dataSource]="profileProviderPF" class="mat-elevation-z8 full-width">

        <ng-container matColumnDef="certifiedHubMedical">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="col-cert">
            <img [src]="element.certifiedHubMedical
                ? 'assets/icons/icon_certificado_concedido.svg'
                : 'assets/icons/icon_certificado_ausente.svg'"
              [matTooltip]="element.certifiedHubMedical ? 'Certificado Hub Medical' : 'Não certificado'" width="24px"
              alt="" />
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nome</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="registerDate">
          <th mat-header-cell *matHeaderCellDef>Data do registro</th>
          <td mat-cell *matCellDef="let element">{{ element.registerDate | date : "dd/MM/yyyy" }}</td>
        </ng-container>

        <ng-container matColumnDef="active">
          <th mat-header-cell *matHeaderCellDef>Ativo</th>
          <td mat-cell *matCellDef="let element">{{ element.active ? "Sim" : "Não" }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">{{ element.status | enumDescription }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <div class="col-actions">
              <button mat-icon-button matTooltip="Editar" (click)="editProfilePF(element)">
                <mat-icon>edit</mat-icon>
              </button>
              @if(!element.certifiedHubMedical){
              <button mat-icon-button matTooltip="Remover Usuário" (click)="removeProviderPF(element.id)">
                <mat-icon>delete</mat-icon>
              </button>}
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsProviderPF"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsProviderPF"></tr>
      </table>
    </div>
  </section>
  }

  @if(profileProviderPJ.length > 0){
  <section class="mb-xl">
    <div class="title-secondary mb-md">Perfil Pessoa Jurídica</div>
    <div class="card">
      <table mat-table [dataSource]="profileProviderPJ" class="mat-elevation-z8 full-width">

        <ng-container matColumnDef="certifiedHubMedical">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="col-cert">
            <img [src]="element.certifiedHubMedical
                ? 'assets/icons/icon_certificado_concedido.svg'
                : 'assets/icons/icon_certificado_ausente.svg'"
              [matTooltip]="element.certifiedHubMedical ? 'Certificado Hub Medical' : 'Não certificado'" width="24px"
              alt="" />
          </td>
        </ng-container>

        <ng-container matColumnDef="companyName">
          <th mat-header-cell *matHeaderCellDef>Empresa</th>
          <td mat-cell *matCellDef="let element">{{ element.companyName }}</td>
        </ng-container>

        <ng-container matColumnDef="registerDate">
          <th mat-header-cell *matHeaderCellDef>Data do registro</th>
          <td mat-cell *matCellDef="let element">{{ element.registerDate | date : "dd/MM/yyyy" }}</td>
        </ng-container>

        <ng-container matColumnDef="active">
          <th mat-header-cell *matHeaderCellDef>Ativo</th>
          <td mat-cell *matCellDef="let element">{{ element.active ? "Sim" : "Não" }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">{{ element.status | enumDescription }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            @if(isLeaderProviderPJ(element.id)){
            <div class="col-actions">
              <button mat-icon-button matTooltip="Editar" (click)="editProfilePJ(element)">
                <mat-icon>edit</mat-icon>
              </button>
              @if(!element.certifiedHubMedical){
              <button mat-icon-button matTooltip="Remover Usuário" (click)="removeProviderPJ(element.id)">
                <mat-icon>delete</mat-icon>
              </button>}
            </div>}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsProviderPJ"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsProviderPJ"></tr>
      </table>
    </div>
  </section>
  }

  <!-- Botões de Ação -->
  <div class="card-footer">
    <button class="btn btn-primary" [routerLink]="'/my-account/profiles/select-new-profile'">
      Adicionar Novo Perfil
    </button>
  </div>

</div>
}

<router-outlet />